import { BASE_URL } from '../../variables'
import { connect } from 'react-redux'
import { addToCartFromRecommanded } from '../../actions'
import { useRef } from 'react'
const RecommandedService = ({ data, loading , addToCartFromRecommanded, category }) => {
    const addedService = useRef()
    const renderRecommandedServices = data.map(x => {
        const addToCart = (service_id) => {
            addedService.current = service_id
            addToCartFromRecommanded(service_id, category)
        }
        return (
            <div className="cart-recommanded-services__item" key={x?.id}>
                <div className="cart-item-image">
                    <img src={BASE_URL + x?.icon} alt={x?.service?.name} width={60} height={60}/>
                </div>
                <div className="cart-item-content">
                    <div className="cart-item-header">{x?.name.length > 35 ? x?.name.substring(0, 32) + "..." : x?.name}</div>
                    <div className="cart-item-price">Rs. {x?.price}</div>
                </div>
                <div className="cart-item-action">
                    <button className={`mini ui button secondary ${loading && x.id === addedService.current && "loading"}`} onClick={() => addToCart(x.id)}>
                        Add to cart
                    </button>
                </div>
            </div>
        )
    })
    return (
        <div className="cart-recommanded__outer">
            <div className="cart-recommanded-services">
                {renderRecommandedServices}
            </div>
        </div>
    )
}

export default connect(null, { addToCartFromRecommanded })(RecommandedService)